import React from 'react'
import {connect} from 'react-redux'
import {wrapDispatch} from 'multireducer'
import {withRouter} from 'react-router'
import TopicProblemSolutions from '../components/TopicProblemSolutions'
import {loadSolutions,addActiveSolution, handleNewContent, makeSelectTopic, makeSelectProblems, makeSelectSolutions} from '../../../redux/modules/topic'
import {showModal} from '../../../redux/modules/modal'
import {postToggleVote} from '../../../redux/modules/content'
import {toJS} from '../../../util/ToJS'
import qs from 'query-string'


class VisibleTopicProblemSolutionsComponent extends React.Component {
  constructor(props) {
    super(props)

  }
  componentDidMount() {
    const {loadSolutions} = this.props
    loadSolutions()
  }
  componentWillReceiveProps(nextProps) {
    const {location, solutions, loadSolutions} = this.props
    const {location: nextLocation, solutions: nextSolutions} = nextProps
    const searchQuery = qs.parse(location.search)
    const nextQuery = qs.parse(nextLocation.search)
    if (searchQuery.id !== nextQuery.id || ((!solutions||!solutions.length) && nextSolutions)) {
      loadSolutions()
    }
  }

  updateSolution(props) {
    const {addActiveSolution, solutions, location} = props
    const searchQuery = qs.parse(location.search)
    const {solution} = searchQuery
    if (solutions && solutions.length && solution) {
      const index = solutions.map((p)=>{return parseInt(p.id)}).indexOf(parseInt(solution))
      if (index !== -1) {
        addActiveSolution(solutions[index].id, solutions, false)
      } else {
        addActiveSolution(solutions[0].id, solutions, false)
      }
    } else if (solutions && solutions.length) {
      addActiveSolution(solutions[0].id, solutions, false)
    }
  }
  render() {
    return (
      <TopicProblemSolutions
        {...this.props}
      />
    )
  }
}

// const mapStateToProps = state => {
//   const activeProblem = selectActiveProblem(state).activeContent;
//   const solutions = selectSolutions(state)
//   return {
//     activeSolutionIds: state.getIn(['topic','activeSolutionIds']),
//     ...solutions
//   }
// }

const makeMapStateToProps = () => {
  const selectTopic = makeSelectTopic()
  const selectProblems = makeSelectProblems(selectTopic)
  const selectSolutions = makeSelectSolutions(selectProblems)
  const mapStateToProps = state => {
    const solutions = selectSolutions(state)
    return {
      activeSolutionIds: state.getIn(['topic','activeSolutionIds']),
      solutions
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = (dispatch, {history, location, topicId, problemId}) => {
  return {
    addActiveSolution: (solutionId, solutions, updateHistory=true) => {
      if (updateHistory) {
        const searchQuery = qs.parse(location.search)
        searchQuery.solution = solutionId
        history.replace({
          search: qs.stringify(searchQuery),
          state: {
            noScrollRestoration: true
          }
        })
      }
      const index = solutions.map((p)=>{return parseInt(p.id)}).indexOf(parseInt(solutionId))
      if (index !== -1) {
        dispatch(addActiveSolution(solutions[index].id))
      } else {
        dispatch(addActiveSolution(solutions[0].id))
      }
    },
    createSolution: () => {
      dispatch(showModal('CONTENT_EDITOR',{
        contentOrTopicId: problemId,
        createOrEdit: 'create',
        contentType: 'problem_solution',
        handleNewContent: (newContent) => {
          dispatch(handleNewContent(topicId, newContent))
          history.replace({
            search: qs.stringify(newContent)
          })
        }
      }))
    },
    toggleVote: (type,id) => wrapDispatch(dispatch, 'leafSolution')(postToggleVote(type,id)),
    loadSolutions: () => dispatch(loadSolutions())
  }
}

const VisibleTopicProblemSolutions = withRouter(connect(
  makeMapStateToProps,
  mapDispatchToProps,
)(toJS(VisibleTopicProblemSolutionsComponent)))

export default VisibleTopicProblemSolutions



// WEBPACK FOOTER //
// ./src/domains/topic/containers/VisibleTopicProblemSolutions.js